import { useQuery } from '@tanstack/react-query';
import { ConvertAmountRangeRes } from '../../apis/bridgeAPI/cryptocurrency/types';
import BridgeAPI from '../../apis/bridgeAPI';
import { BRIDGE_CRYPTOCURRENCIES_QUERY_KEY } from '../../query/keys';
import { ONE_MINUTE } from '../../query';

// NOTE : This hooks is commonly used for min/max amount, tax and max amount letters
const useTokensInitialData = () => {
  const { data: tokensInitialData } = useQuery<ConvertAmountRangeRes[], Error>(
    [BRIDGE_CRYPTOCURRENCIES_QUERY_KEY],
    BridgeAPI.getConvertAmountRangeAll,
    {
      staleTime: ONE_MINUTE * 5,
    },
  );

  return tokensInitialData ?? null;
};

export default useTokensInitialData;
